import {Map} from 'immutable';
import {
  CLOSE_EDIT_PROFILE_DIALOG,
  OPEN_EDIT_PROFILE_DIALOG,
  OPEN_USER_PROFILE_MENU
} from '../actions';

import {
  SUBMIT_USER_PROFILE_FORM_FULFILLED,
  SUBMIT_USER_PROFILE_FORM_REJECTED,
} from '../../userProfile/actions';


const initialState = new Map({
  isOpen: false,
  editProfileIsOpen: false,
  userProfile: new Map(),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case OPEN_USER_PROFILE_MENU:
      return state.set('isOpen', action.payload);

    case OPEN_EDIT_PROFILE_DIALOG:
      return state.set('editProfileIsOpen', true);

    case CLOSE_EDIT_PROFILE_DIALOG:
    case SUBMIT_USER_PROFILE_FORM_REJECTED:
    case SUBMIT_USER_PROFILE_FORM_FULFILLED:
      return state.set('editProfileIsOpen', false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/layout/reducers/userProfileMenu.js